import { IssueReportLoadable } from 'containers/IssueReport/IssueReportLoadable';
import Reschedule from 'containers/IssueReport/Reschedule';
import SchedulesDates from 'containers/IssueReport/Reschedule/SchedulesDates';
import ROUTES, { routesNames } from './constants';

const createIssueReportRoutes = () =>
  [
    {
      path: ROUTES.REPORT_ISSUE(),
      indexRoute: {
        name: routesNames.reportIssue,
        defaultRedirect: '/',
        component: IssueReportLoadable,
        exact: true,
      },
      childRoutes: [
        {
          path: ROUTES.RESCHEDULE_REPORTED_SESSION(),
          name: routesNames.rescheduleReportedSession,
          component: Reschedule,
          defaultRedirect: '/',
        },
        {
          path: ROUTES.RESCHEDULE_DATE_AND_TIME(),
          name: routesNames.rescheduleDateAndTime,
          component: SchedulesDates,
          defaultRedirect: '/',
        },
      ],
    },
  ];

export default createIssueReportRoutes;
